var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('toast',{ref:"global_snackbar"}),_c('message-dialog',{ref:"global_dialog"}),_c('overlay',{ref:"global_overlay"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }